import { Box } from '@chakra-ui/layout';
import { useDraggable } from '@dnd-kit/core';
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import styles from './EditableGrid.module.css';
import type { Direction } from './Resizer';

export type ResizeEdgeProps = PropsWithChildren<{
  id: string;
  activeResizeEdge: Direction | null;
  direction: Direction;
}>;

export const ResizeEdge = ({ id, direction }: ResizeEdgeProps) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: `${id}-resize-${direction}`,
    data: { direction },
  });

  const size = 25;

  const svg = (() => {
    switch (direction) {
      case 'nw':
        return (
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 24.5V9.5C0.5 4.52944 4.52944 0.5 9.5 0.5H24.5"
              stroke="#3DBFEC"
              strokeLinecap="round"
            />
          </svg>
        );
      case 'ne':
        return (
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.499999 0.499999L15.5 0.5C20.4706 0.5 24.5 4.52944 24.5 9.5L24.5 24.5"
              stroke="#3DBFEC"
              strokeLinecap="round"
            />
          </svg>
        );
      case 'sw':
        return (
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.5 24.5L9.5 24.5C4.52944 24.5 0.500001 20.4706 0.500001 15.5L0.500003 0.499999"
              stroke="#3DBFEC"
              strokeLinecap="round"
            />
          </svg>
        );
      // biome-ignore lint/complexity/noUselessSwitchCase: migrated from develop
      case 'se':
      default:
        return (
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 24.5 0.5 V 15.5 C 24.5 20.4706 20.4706 24.5 15.5 24.5 H 0.5"
              stroke="#3DBFEC"
              strokeLinecap="round"
            />
          </svg>
        );
    }
  })();

  return (
    <Box
      position="absolute"
      zIndex={3}
      ref={setNodeRef}
      style={{ width: `${size}px`, height: `${size}px` }}
      data-direction={direction}
      className={classNames(styles.resizeEdge)}
      {...listeners}
      {...attributes}
    >
      {svg}
    </Box>
  );
};
